<template>
  <section class="terms-conditions-view">
    <div class="terms-conditions-view__content-wrapper">
    <TermsDisplay class="terms-conditions-view__terms-display" />

    <div class="terms-conditions-view__footer">
    <solid-button
      :to="{ name: 'home' }"
      buttonIcon="chevron_left"
    >
    Back
    </solid-button>
    </div>
    </div>
  </section>
</template>

<script>
import TermsDisplay from './../components/terms-display';

export default {
  name: 'terms-conditions-view',
  components: {
    TermsDisplay
  }
};
</script>

<style lang="scss">
.terms-conditions-view {
  font-family: 'proxima-nova';
  padding: 1px;
  &__content-wrapper {
    @include grid-container();
  }

  &__terms-display {
    padding-top: $size-padding-top-terms-conditions-view-content-large;
    background: transparent;
    height: auto;
    padding-bottom: $size-padding-bottom-terms-conditions-view-terms-display-large;
    margin: 0 auto;
  }

  &__footer {
    text-align: center;
    padding-bottom: $size-padding-bottom-terms-conditions-view-content-large;
  }

  @include global-media('small') {
    &__content-wrapper {
      padding-top: $size-padding-top-terms-conditions-view-content-small;
      padding-bottom: $size-padding-bottom-terms-conditions-view-content-small;
    }

    &__terms-display {
      padding-bottom: $size-padding-bottom-terms-conditions-view-terms-display-small;
    }
  }
}

</style>
